import React, { useEffect, useMemo } from 'react';
import useInput from 'lib/hooks/useInput';
import { Grid, TextField } from '@material-ui/core';
import MuiWrapper from 'components/common/input/MuiWrapper';
import { pageUrl } from 'lib/mapper';
import { useShallowAppSelector } from 'store/hooks';
import { T } from 'components/common/text';
import { AppActions, EmployeeActions } from 'store/actionCreators';
import AuthLayout from 'components/auth/AuthLayout';
import CustomSpan from 'components/common/text/CustomSpan';
import { color } from 'styles/utils';
import { useHistory } from 'react-router-dom';
import { useDidUpdateEffect } from 'lib/utils';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import AlertModalContent from 'components/common/modal/contents/AlertModalContent';
interface IUserInfo {
  email: string;
  groupCode: string;
  nickname: string;
}

export default function PasswordResetContainer({ jestSubmit }: { jestSubmit: (e: any) => void }) {
  const {
    employeeByKeyData: { userInfo },
    editEmployeePasswordSuccess,
  }: {
    employeeByKeyData: { userInfo: IUserInfo };
    editEmployeePasswordSuccess: boolean;
  } = useShallowAppSelector(state => ({
    employeeByKeyData: state.employee.employeeByKey.data || { userInfo: {} },
    editEmployeePasswordSuccess: state.employee.editEmployeePassword.success,
  }));
  const history = useHistory();
  const { t } = useTranslation();
  const location = history.location;
  const { pathname, search, state } = location as { pathname: string; search: string; state: any };
  const resetKey = search.substring(10);
  // const resetKey = useMemo(() => {
  //   return new URLSearchParams(history.location.search).get('resetKey');
  // }, []);
  const password = useInput('');
  const confirmPassword = useInput('');

  const isValidForm = useMemo(() => {
    const passwordValue = password.value?.trim();
    const confirmPasswordValue = confirmPassword.value?.trim();

    return passwordValue === confirmPasswordValue && passwordValue && confirmPasswordValue;
  }, [password.value, confirmPassword.value]);

  // SECTION: function

  const showKeyError = () => {
    AppActions.show_toast({
      type: 'error',
      message: 'Invalid page.\nPlease resend the link.',
    });
  };

  const handleSubmit = () => {
    const submitData = {
      email: userInfo.email,
      password: password.value,
      confirmPassword: confirmPassword.value,
    };
    // test code
    jestSubmit(submitData);

    if (!resetKey) {
      showKeyError();
      return;
    }

    EmployeeActions.edit_employee_password_request({
      resetKey,
      groupCode: userInfo.groupCode,
      email: userInfo.email,
      newPassword: password.value,
    });
  };

  const handleNavigateLogin = () => {
    history.push({
      pathname: pageUrl.auth.signIn,
      state: { nickname: userInfo.nickname || '', email: userInfo.email },
    });
  };

  const popupComment: { title: string; mainText: string; subText: string } = {
    title: t('GLOBAL_SUCCESS'),
    mainText: t('SUCCESS_PASSWORD_CHANGE'),
    subText: '',
  };

  const changeSucessPopup = () => {
    AppActions.add_popup({
      isOpen: true,
      isCloseIcon: true,
      title: '',
      content: (
        <AlertModalContent
          title={popupComment.title}
          mainText={popupComment.mainText}
          subText={popupComment.subText}
        />
      ),
      onClick() {
        window.close();
      },
      onCancel() {
        window.close();
      },
    });
  };

  // SECTION: DidMount

  useEffect(() => {
    if (!resetKey) {
      showKeyError();
      return;
    }
    EmployeeActions.fetch_employee_by_key_request({ resetKey });
  }, []);

  // SECTION: DidUpdate

  useDidUpdateEffect(() => {
    if (editEmployeePasswordSuccess) {
      // handleNavigateLogin();
      changeSucessPopup();
    }
  }, [!!editEmployeePasswordSuccess]);

  return (
    <AuthLayout
      title={<T>GLOBAL_PASSWORD_RESET</T>}
      buttonText={<T>GLOBAL_OK</T>}
      isValidForm={isValidForm}
      onSubmit={handleSubmit}
    >
      <Grid item xs={12} className="authLayout__form_row">
        <MuiWrapper>
          <TextField
            id="email"
            name="email"
            placeholder="email"
            variant="outlined"
            fullWidth
            autoComplete="off"
            value={userInfo.email || ''}
            // value="vxggangxv@naver.com"
            inputProps={{
              readOnly: true,
            }}
          />
        </MuiWrapper>
      </Grid>

      <Grid item xs={12} className="authLayout__form_row">
        <MuiWrapper>
          <TextField
            id="password"
            name="password"
            placeholder="password"
            variant="outlined"
            fullWidth
            autoComplete="off"
            value={password.value}
            onChange={password.onChange}
          />
        </MuiWrapper>
      </Grid>

      <Grid item xs={12} className="authLayout__form_row">
        <MuiWrapper>
          <TextField
            id="confirmPassword"
            name="confirmPassword"
            placeholder="confirmPassword"
            variant="outlined"
            fullWidth
            autoComplete="off"
            value={confirmPassword.value}
            onChange={confirmPassword.onChange}
            onKeyUp={e => e.key === 'Enter' && handleSubmit()}
          />
        </MuiWrapper>
      </Grid>
    </AuthLayout>
  );
}
